import { render, staticRenderFns } from "./SearchPhysicianIcon.vue?vue&type=template&id=11f04191&scoped=true&"
import script from "./SearchPhysicianIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SearchPhysicianIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f04191",
  null
  
)

export default component.exports